module.exports = __webpack_public_path__ + "static/img/米家双区洗双洗烘洗衣机.e10f7156.png";